import React from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import 'react-table/react-table.css';
import Pagination from 'react-js-pagination';
import { LinearProgress } from 'react-md';
import { MenuItem, Dropdown } from 'react-bootstrap';
import '../../../node_modules/react-md/dist/react-md.indigo-blue.min.css';
import 'bootstrap-datepicker/js/bootstrap-datepicker.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css';
import Loader from '../../_components/loader';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import { AdminUrls } from '../../network/config';
import { connect } from 'react-redux';
import { removeData } from '../../store/action';
import './style.css';

const moment = require('moment');

const LoadHost_Url = AdminUrls.COMMON.LOADHOST;
const excelDownload_Url = AdminUrls.COMMON.CPDMEMBERPDF;
const memberHours_Url = AdminUrls.USER.MEMBERCPDHOURS;
const memberCpd_Url = AdminUrls.USER.MEMBERCPD;
const delete_Url = AdminUrls.USER.DELETEMEMBERCPD;
var currentYear = new Date().getFullYear();

class MyCpdReport extends React.Component {
  constructor() {
    super();

    this.handlePageChange = this.handlePageChange.bind(this);
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.deleteCPDRecord = this.deleteCPDRecord.bind(this);
    this.downloadExcel = this.downloadExcel.bind(this);
    this.getLoadCpd = this.getLoadCpd.bind(this);
    this.getMemberHour = this.getMemberHour.bind(this);
    this.getMemberCpd = this.getMemberCpd.bind(this);
    this.searchData = this.searchData.bind(this);
    this.editViewHandler = this.editViewHandler.bind(this);
    this.addViewHandler = this.addViewHandler.bind(this);

    this.state = {
      host_dict: {},
      host_list: [],
      overdue_hours: 0,
      overdue_minutes: 0,
      required_hours: 0,
      total_hours: 0,
      total_minutes: 0,
      start_date_iso: '',
      start_date: '',
      dashboard_records: [],
      course_name: '',
      host_name: '',
      location_name: '',
      host_id: '',
      year: new Date().getFullYear(),
      dashBoxYear: '',
      date_selected: '',
      sort: {
        column: 'CourseName',
        direction: 'desc',
      },
      unauthorized: false,

      memId: '',
      cpdDate: '',
      cpdCourseName: '',
      cpdLocationName: '',
      cpdHostName: '',
      UserId: '',
      totalPages: 0,
      totalCount: 0,
      per_page: 10,
      activePage: 1,
      mainLoading: false,
      emptyDivMsg: 'There is no data to show in the grid.',
      loadHost: [],
      cpdYear: currentYear,
    };
    this.controller = new AbortController();
  }

  downloadExcel(year) {
    var fileType = 'application/vnd.ms-excel';
    var name;
    this.setState({ mainLoading: true });
    axios(excelDownload_Url, {
      params: {
        UserName: this?.state?.UserId,
        Year: year,
      },
      responseType: 'blob',
      method: 'GET',
      signal: this.controller.signal,
      withCredentials: true,
      credentials: 'include',
      headers: {
        Authorization:
          `${this.props.user.token_type} ` + this.props.user.access_token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        var blob = new Blob([response.data], { type: fileType });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, name);
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'MyCPDReport.pdf');
          document.body.appendChild(link);
          link.click();
        }
      })
      .then((data) => {
        this.setState({ mainLoading: false });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  handlePageChange(pageNumber) {
    this.setState(
      {
        activePage: pageNumber,
      },
      () => {
        this.getMemberCpd();
      }
    );
  }

  componentDidMount() {
    const { memberId, userId } = this.props.match.params;
    this.setState(
      {
        UserId: userId,
        memId: memberId,
      },
      () => {
        this.getMemberCpd();
        this.getMemberHour();
      }
    );
    this.getLoadCpd();
  }

  getLoadCpd() {
    this.setState({ mainLoading: true });

    axios
      .get(LoadHost_Url, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loadHost: data,
          mainLoading: false,
        });

        this.getCpdCompliantReport(1, this?.state?.yearCpd);
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  clearSearchFilters() {
    this.setState(
      {
        mainLoading: true,
        dashboard_records: [],
        cpdYear: currentYear,
        sort: {
          column: 'StartDate',
          direction: 'desc',
        },
        totalPages: 0,
        totalCount: 0,
        per_page: 10,
        activePage: 1,
        unauthorized: false,
        cpdDate: '',
        cpdCourseName: '',
        cpdLocationName: '',
        cpdHostName: '',
      },
      () => {
        this.getMemberCpd();
      }
    );
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === 'asc'
        ? 'desc'
        : 'asc'
      : 'desc';
    this.setState(
      {
        sort: {
          column,
          direction,
        },
      },
      () => {
        this.getMemberCpd();
      }
    );
  };

  setArrow = (column) => {
    let className = 'fa fa-sort';
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === 'asc' ? '-asc' : '-desc';
    }
    return className;
  };

  deleteCPDRecord(workflowId) {
    if (window.confirm('Are you sure you want to delete?')) {
      axios
        .get(delete_Url, {
          params: {
            workflowId: workflowId,
          },
          method: 'GET',
          signal: this.controller.signal,
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization:
              `${this.props.user.token_type} ` + this.props.user.access_token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then((response) => response.data)
        .then((data) => {
          this.getMemberCpd();
          NotificationManager.success('CPD record Deleted');
        })
        .catch((error) => {
          if (error?.response?.status && error?.response?.status === 401) {
            this.props.signOut();
          }
        });
    }
  }

  searchData() {
    this.getMemberCpd();
    this.getMemberHour();
  }

  getMemberHour() {
    this.setState({
      mainLoading: true,
    });
    axios
      .get(memberHours_Url, {
        params: {
          Year: this?.state?.cpdYear ? this?.state?.cpdYear : currentYear,
          UserName: this?.state?.UserId ? this.state?.UserId : '',
        },
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          mainLoading: false,
          dashBoxYear: this.state.cpdYear ? this.state.cpdYear : currentYear,
          overdue_hours: data[0].OverdueHours,
          overdue_minutes: data[0].OverdueMinutes,
          required_hours: data[0].RequiredHours,
          total_hours: data[0].TotalHours,
          total_minutes: data[0].TotalMinutes,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  getMemberCpd() {
    let reverse = this.state.sort.direction;
    let sortBy = this.state.sort.column;
    this.setState({
      mainLoading: true,
    });

    reverse = reverse === 'asc' ? false : true;
    let locationName = this.state.cpdLocationName;
    let CourseName = this.state.cpdCourseName;
    let year = this.state.cpdYear;
    let DateMem = this.state.cpdDate;
    let host = this.state.cpdHostName;
    if (!year) {
      year = currentYear;
    }
    let obj = {
      Year: year,
      UserName: this.state?.UserId,
      page: this?.state?.activePage,
      pageSize: this.state.per_page,
      reverse: reverse,
      sortBy: sortBy,
    };

    if (locationName) {
      obj.LocationName = locationName;
    }

    if (CourseName) {
      obj.CourseName = CourseName;
    }
    if (year) {
      obj.Year = year;
    } else {
    }
    if (DateMem) {
      obj.Date = DateMem;
    }
    if (host) {
      obj.HostId = host;
    }

    axios
      .get(memberCpd_Url, {
        params: obj,
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          dashboard_records: data?.Items,
          totalPages: data?.TotalPages,
          activePage: data?.Page,
          totalCount: data?.TotalCount,
          mainLoading: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  editViewHandler(id, mode, item) {
    if (this.state.memId) {
      item.UserId = this.state.memId;
    }
    this.props.history.push({
      pathname: `/myCpdRecord/${id}/edit`,
      state: item,
    });
  }

  addViewHandler(id, mode) {
    this.props.history.push({
      pathname: `/myCpdRecord/${id}/add`,
    });
  }

  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let dashboard_records;

    if (this.state.dashboard_records !== null) {
      dashboard_records = this.state.dashboard_records.map(
        (dashboard_record, index) => {
          return (
            <tr key={index}>
              <td>{dashboard_record.CPDTypeName}</td>
              <td>{dashboard_record.CourseName}</td>
              <td>
                {dashboard_record.Hours}h{' '}
                {dashboard_record.Minutes ? `${dashboard_record.Minutes}m` : ''}
              </td>
              <td>
                {dashboard_record.CompletionDate
                  ? moment(dashboard_record.CompletionDate).format('ll')
                  : 'na'}
              </td>
              <td>{dashboard_record.Venue}</td>
              <td>{dashboard_record.Trainer}</td>
              <td>
                {this?.state?.loadHost?.length &&
                  this?.state?.loadHost
                    ?.filter((item) => item.ID === dashboard_record.HostId)
                    .map((item) => item.Name)}
              </td>
              <td>
                {dashboard_record.StartDate
                  ? moment(dashboard_record.StartDate).format('ll')
                  : 'na'}
              </td>
              <td>
                {dashboard_record.CourseId === 0 &&
                !dashboard_record.CourseId ? (
                  <i
                    className="fa fa-clock-o ng-scope"
                    role="button"
                    tabIndex="0"
                    data-toggle="tooltip"
                    title="Waiting for an approval"
                    data-original-title="Edit CPD"
                    style={{
                      fontSize: '21px',
                      cursor: 'pointer',
                      marginLeft: '25px',
                      color: 'black',
                    }}
                  ></i>
                ) : (
                  <div
                    style={{
                      whiteSpace: 'nowrap',
                      display:
                        dashboard_record.CourseId != null ? 'block' : 'none',
                    }}
                  >
                    <button
                      style={{
                        fontSize: '18px',
                        cursor: 'pointer',
                        marginLeft: '10px',
                        color: 'black',
                        background: 'transparent',
                        border: '0px',
                      }}
                      onClick={() =>
                        this.editViewHandler(
                          dashboard_record?.CPDWorkflowId,
                          'edit',
                          dashboard_record
                        )
                      }
                    >
                      <i
                        title=""
                        className="fa fa-edit ng-scope"
                        role="button"
                        tabIndex="0"
                        data-original-title="Edit CPD"
                      >
                        {' '}
                      </i>
                    </button>
                    <button
                      style={{
                        fontSize: '18px',
                        cursor: 'pointer',
                        marginLeft: '10px',
                        color: 'black',
                        background: 'transparent',
                        border: '0px',
                      }}
                      onClick={() =>
                        this.deleteCPDRecord(dashboard_record.CPDWorkflowId)
                      }
                    >
                      <i
                        title=""
                        className="fa fa-trash ng-scope"
                        role="button"
                        tabIndex="0"
                        data-original-title="Delete CPD"
                      >
                        {' '}
                      </i>
                    </button>
                  </div>
                )}

                <div
                  style={{
                    fontSize: '21px',
                    cursor: 'pointer',
                    marginLeft: '25px',
                    color: 'black',
                    display:
                      dashboard_record.CourseId != null ? 'none' : 'block',
                  }}
                >
                  <i
                    className="fa fa-clock-o ng-scope"
                    title="Waiting for an approval"
                  >
                    {' '}
                  </i>
                </div>
              </td>
            </tr>
          );
        }
      );
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="row" style={{ marginBottom: '1.8rem' }}>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="dashboard_box_mcpd">
                <div className="pull-right green_icon">
                  <i className="fa fa-graduation-cap"> </i>
                </div>
                {this.state.required_hours}{' '}
                <span className="mediumfont_mcpd">Hour</span>
                <div className="white_progress_mcpd">
                  <div
                    className="white_progress_inner_mcpd"
                    style={{ width: '100%' }}
                  >
                    {' '}
                  </div>
                </div>
                <div className="dashboard-box-footer-mcpd" id="dashBox1">
                  <div id="courseToDo">
                    <span>Required</span>
                    <span style={{ float: 'right' }}>
                      {this.state.dashBoxYear}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="dashboard_box_mcpd">
                <div className="pull-right green_icon">
                  <i className="fa fa-clock-o"> </i>
                </div>
                {this.state.overdue_hours > 0 ? this.state.overdue_hours : '0'}{' '}
                <span className="mediumfont_mcpd">
                  Hour{' '}
                  {this.state.overdue_minutes > 0
                    ? this.state.overdue_minutes
                    : '0'}{' '}
                  Mins
                </span>
                <div className="white_progress_mcpd">
                  <div
                    className="white_progress_inner_mcpd"
                    style={{ width: '100%' }}
                  >
                    {' '}
                  </div>
                </div>
                <div
                  className="dashboard-box-footer-mcpd"
                  id="remainingdashBox"
                >
                  <div id="courseToDo">
                    <span>Remaining</span>
                    <span style={{ float: 'right' }}>
                      {this.state.dashBoxYear}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="dashboard_box_mcpd">
                <div className="pull-right green_icon">
                  <i className="fa fa-trophy"> </i>
                </div>
                {this.state.total_hours}{' '}
                <span className="mediumfont_mcpd">
                  Hour {this.state.total_minutes} Mins
                </span>
                <div className="white_progress_mcpd">
                  <div
                    className="white_progress_inner_mcpd"
                    style={{ width: '100%' }}
                  >
                    {' '}
                  </div>
                </div>
                <div
                  className="dashboard-box-footer-mcpd"
                  id="completedDashBox"
                >
                  <div id="courseToDo">
                    <span>Completed</span>
                    <span style={{ float: 'right' }}>
                      {this.state.dashBoxYear}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: '10px' }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {' '}
                Search
              </i>
            </div>
            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: '1rem 1rem' }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Course Name</label>
                        <input
                          type="CourseName"
                          className="form-control"
                          value={this.state.cpdCourseName}
                          onChange={(e) =>
                            this.setState({ cpdCourseName: e.target.value })
                          }
                          id="CourseName"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              this.searchData();
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Year</label>
                        <select
                          value={this.state.cpdYear}
                          className="form-control"
                          onChange={(e) =>
                            this.setState({
                              cpdYear: e.target.value,
                            })
                          }
                          id="sel1"
                        >
                          <option value={'2023'}>2023</option>
                          <option value={'2024'}>2024</option>
                          <option value={'2025'} defaultValue>
                            2025
                          </option>
                          <option value={'2026'}>2026</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Location Name</label>
                        <input
                          type="Location Name"
                          value={this.state.cpdLocationName}
                          className="form-control"
                          id="Location Name"
                          onChange={(e) =>
                            this.setState({ cpdLocationName: e.target.value })
                          }
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              this.searchData();
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>date</label>

                        <input
                          type="date"
                          className="form-control"
                          id="date"
                          value={this.state.cpdDate}
                          onChange={(e) =>
                            this.setState({ cpdDate: e.target.value })
                          }
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group admin-forms">
                        <label>Host</label>
                        <select
                          className="form-control"
                          onChange={(e) =>
                            this.setState({ cpdHostName: e.target.value })
                          }
                          value={this.state.cpdHostName}
                        >
                          <option value="" disabled hidden></option>
                          {this?.state?.loadHost?.length &&
                            this?.state?.loadHost?.map((item, index) => {
                              return (
                                <option key={index} value={item?.ID}>
                                  {item?.Name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: '10px' }}
                      onClick={this.searchData}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{' '}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={this.clearSearchFilters}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{' '}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="gridTopButtons">
            <button
              type="button"
              onClick={() => window.print()}
              className="btn btn-danger btn-circle btn-lg "
            >
              <i className="fa fa-print"> </i>
            </button>

            <Dropdown id="dropdown-custom-1">
              <Dropdown.Toggle
                className="btn btn-success btn-circle btn-lg"
                style={{ marginLeft: '10px' }}
                noCaret
              >
                <i className="fa fa-file-pdf-o"> </i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <MenuItem
                  onClick={() => {
                    this.downloadExcel('All');
                  }}
                  eventKey="4"
                >
                  All
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    this.downloadExcel(2023);
                  }}
                  eventKey="4"
                >
                  2023
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    this.downloadExcel(2024);
                  }}
                  eventKey="5"
                >
                  2024
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    this.downloadExcel(2025);
                  }}
                  eventKey="6"
                >
                  2025
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    this.downloadExcel(2026);
                  }}
                  eventKey="7"
                >
                  2026
                </MenuItem>
              </Dropdown.Menu>
            </Dropdown>

            <button
              className="btn btn-primary btn-circle btn-lg"
              style={{ marginLeft: '10px' }}
              onClick={() => this.addViewHandler(this?.state?.memId, 'add')}
            >
              <i className="fa fa-plus"></i>
            </button>
          </div>
        </div>
        <div className="col-table">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-bordered table-hover table-condensed">
            <thead>
              <tr className="header">
                <th role="button" onClick={this.onSort('CPDTypeName')}>
                  Course Type <i className={this.setArrow('CPDTypeName')}> </i>
                </th>
                <th role="button" onClick={this.onSort('CourseName')}>
                  Course<i className={this.setArrow('CourseName')}> </i>
                </th>
                <th role="button" onClick={this.onSort('Hours')}>
                  Completed Hours<i className={this.setArrow('Hours')}> </i>
                </th>
                <th role="button" onClick={this.onSort('CompletionDate')}>
                  Completion Date
                  <i className={this.setArrow('CompletionDate')}> </i>
                </th>
                <th role="button" onClick={this.onSort('Venue')}>
                  Venue<i className={this.setArrow('Venue')}> </i>
                </th>
                <th role="button" onClick={this.onSort('Trainer')}>
                  Trainer<i className={this.setArrow('Trainer')}> </i>
                </th>
                <th role="button" onClick={this.onSort('HostId')}>
                  Host<i className={this.setArrow('HostId')}> </i>
                </th>
                <th role="button" onClick={this.onSort('StartDate')}>
                  Start Date<i className={this.setArrow('StartDate')}> </i>
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>{dashboard_records}</tbody>
          </table>
          {dashboard_records.length > 0 ? '' : this.state.emptyDivMsg}
        </div>
        <div>
          <Pagination
            prevPageText="Previous"
            nextPageText="Next"
            firstPageText="First"
            lastPageText="Last"
            activePage={this.state.activePage}
            itemsCountPerPage={this.state.per_page}
            totalItemsCount={this.state.totalCount}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MyCpdReport));
